(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sundae-cart-feedback"] && !Shopify.designMode) return;
  try {
    (() => {
    const initCartFeedback = (toast) => {
      if (toast.dataset.initialized === 'true') return;
      toast.dataset.initialized = 'true';
      const message = toast.querySelector('[data-cart-toast-message]');
      const closeButton = toast.querySelector('[data-close-cart-toast]');
      let dismissTimer;

      const showToast = (text, isError = false) => {
        window.clearTimeout(dismissTimer);
        message.textContent = text;
        toast.classList.toggle('is-error', isError);
        toast.hidden = false;
        dismissTimer = window.setTimeout(() => { toast.hidden = true; }, 3500);
      };

      const refreshCartCount = async () => {
        const response = await fetch(toast.dataset.cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        document.querySelectorAll('[data-cart-count]').forEach((count) => {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-cart-link]').forEach((link) => {
          link.setAttribute('aria-label', link.dataset.cartLabel.replace('[count]', cart.item_count));
        });
      };

      document.addEventListener('sundae:cart-added', (event) => {
        showToast(event.detail?.message || toast.dataset.addedMessage);
        refreshCartCount().catch(() => {});
      });

      document.addEventListener('submit', async (event) => {
        const form = event.target.closest('.sundae-card__form, .sundae-product__form');
        if (!form) return;
        event.preventDefault();
        const submitter = event.submitter;
        const buyNow = Boolean(submitter?.hasAttribute('data-sundae-buy-now'));
        const formOwner = form.closest('[data-product-section]') || form;
        const buttons = [...formOwner.querySelectorAll('button[type="submit"]')];
        const buttonStates = buttons.map((button) => ({ button, text: button.textContent, disabled: button.disabled }));
        buttons.forEach((button) => { button.disabled = true; });
        if (submitter?.dataset.loadingLabel) submitter.textContent = submitter.dataset.loadingLabel;
        try {
          const response = await fetch(toast.dataset.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || toast.dataset.errorMessage);
          await refreshCartCount();
          if (buyNow) {
            window.location.assign(toast.dataset.checkoutUrl);
            return;
          }
          showToast(toast.dataset.addedMessage);
        } catch (error) {
          showToast(error.message || toast.dataset.errorMessage, true);
        } finally {
          buttonStates.forEach((state) => {
            state.button.textContent = state.text;
            state.button.disabled = state.disabled;
          });
        }
      });

      closeButton.addEventListener('click', () => {
        window.clearTimeout(dismissTimer);
        toast.hidden = true;
      });
    };

    const toast = document.querySelector('[data-sundae-cart-toast]');
    if (toast) initCartFeedback(toast);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sundae-cart-system"] && !Shopify.designMode) return;
  try {
    (() => {
    const toast = document.querySelector('[data-sundae-cart-toast]');
    const drawer = document.querySelector('[data-sundae-cart-drawer]');
    if (!toast || !drawer || toast.dataset.initialized === 'true') return;
    toast.dataset.initialized = 'true';
    const message = toast.querySelector('[data-cart-toast-message]');
    const closeToastButton = toast.querySelector('[data-close-cart-toast]');
    const drawerContent = drawer.querySelector('[data-cart-drawer-content]');
    const currencyCode = drawer.dataset.currencyCode || 'INR';
    let dismissTimer;
    let drawerBusy = false;

    const formatMoney = (cents) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: currencyCode, maximumFractionDigits: 0 }).format(cents / 100);
    const make = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const updateCartCount = (cart) => {
      document.querySelectorAll('[data-cart-count]').forEach((count) => {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      });
      document.querySelectorAll('[data-cart-link]').forEach((link) => {
        if (link.dataset.cartLabel) link.setAttribute('aria-label', link.dataset.cartLabel.replace('[count]', cart.item_count));
      });
    };
    const showToast = (text, isError = false) => {
      window.clearTimeout(dismissTimer);
      message.textContent = text;
      toast.classList.toggle('is-error', isError);
      toast.hidden = false;
      dismissTimer = window.setTimeout(() => { toast.hidden = true; }, 3500);
    };
    const fetchCart = async () => {
      const response = await fetch(drawer.dataset.cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(drawer.dataset.errorMessage);
      return response.json();
    };
    const renderDrawer = (cart) => {
      updateCartCount(cart);
      drawerContent.replaceChildren();
      if (!cart.item_count) {
        const empty = make('div', 'sundae-cart-drawer__empty');
        empty.append(make('p', '', drawer.dataset.emptyMessage));
        const home = make('a', 'button', drawer.dataset.homeLabel);
        home.href = drawer.dataset.homeUrl;
        empty.append(home);
        drawerContent.append(empty);
        return;
      }
      const items = make('div', 'sundae-cart-drawer__items');
      cart.items.forEach((item, index) => {
        const article = make('article', 'sundae-cart-drawer__item');
        const imageLink = make('a', 'sundae-cart-drawer__image');
        imageLink.href = item.url;
        if (item.image) {
          const image = make('img');
          image.src = item.image;
          image.alt = item.product_title;
          image.loading = 'lazy';
          imageLink.append(image);
        }
        const copy = make('div', 'sundae-cart-drawer__item-copy');
        const title = make('h3');
        const titleLink = make('a', '', item.product_title);
        titleLink.href = item.url;
        title.append(titleLink);
        copy.append(title);
        if (item.variant_title && item.variant_title !== 'Default Title') copy.append(make('p', 'sundae-cart-drawer__meta', item.variant_title));
        Object.entries(item.properties || {}).forEach(([name, value]) => {
          if (!name.startsWith('_') && value) copy.append(make('p', 'sundae-cart-drawer__meta', `${name}: ${value}`));
        });
        copy.append(make('p', 'sundae-cart-drawer__line-price', formatMoney(item.final_line_price)));
        const actions = make('div', 'sundae-cart-drawer__item-actions');
        const quantity = make('div', 'sundae-cart-drawer__quantity');
        const minus = make('button', '', '−');
        minus.type = 'button';
        minus.setAttribute('aria-label', drawer.dataset.decreaseTemplate.replace('[title]', item.product_title));
        const input = make('input');
        input.type = 'number';
        input.min = '0';
        input.step = '1';
        input.inputMode = 'numeric';
        input.value = item.quantity;
        input.setAttribute('aria-label', drawer.dataset.quantityTemplate.replace('[title]', item.product_title));
        const plus = make('button', '', '+');
        plus.type = 'button';
        plus.setAttribute('aria-label', drawer.dataset.increaseTemplate.replace('[title]', item.product_title));
        const remove = make('button', 'sundae-cart-drawer__remove', drawer.dataset.removeLabel);
        remove.type = 'button';
        quantity.append(minus, input, plus);
        actions.append(quantity, remove);
        const line = index + 1;
        minus.addEventListener('click', () => changeLine(line, Math.max(0, item.quantity - 1)));
        plus.addEventListener('click', () => changeLine(line, item.quantity + 1));
        input.addEventListener('change', () => changeLine(line, Math.max(0, Math.floor(Number(input.value) || 0))));
        remove.addEventListener('click', () => changeLine(line, 0));
        article.append(imageLink, copy, actions);
        items.append(article);
      });
      const footer = make('footer', 'sundae-cart-drawer__footer');
      footer.append(make('p', 'sundae-cart-drawer__count', drawer.dataset.itemsTemplate.replace('[count]', cart.item_count)));
      const total = make('div', 'sundae-cart-drawer__total');
      total.append(make('span', '', drawer.dataset.totalLabel), make('span', '', formatMoney(cart.total_price)));
      const checkoutForm = make('form', 'sundae-cart-drawer__checkout');
      checkoutForm.method = 'post';
      checkoutForm.action = drawer.dataset.cartPageUrl;
      const checkout = make('button', 'button', drawer.dataset.checkoutLabel);
      checkout.type = 'submit';
      checkout.name = 'checkout';
      checkoutForm.append(checkout);
      const home = make('a', 'sundae-cart-drawer__home', drawer.dataset.homeLabel);
      home.href = drawer.dataset.homeUrl;
      footer.append(total, checkoutForm, home);
      drawerContent.append(items, footer);
    };
    const showDrawerState = (text) => {
      const state = make('div', 'sundae-cart-drawer__loading');
      state.append(make('p', '', text));
      drawerContent.replaceChildren(state);
    };
    const refreshDrawer = async () => {
      showDrawerState(drawer.dataset.loadingMessage);
      try {
        const cart = await fetchCart();
        renderDrawer(cart);
      } catch (error) {
        showDrawerState(error.message || drawer.dataset.errorMessage);
      }
    };
    const changeLine = async (line, quantity) => {
      if (drawerBusy) return;
      drawerBusy = true;
      drawer.querySelectorAll('button,input').forEach((control) => { control.disabled = true; });
      try {
        const response = await fetch(drawer.dataset.cartChangeUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        if (!response.ok) throw new Error(drawer.dataset.errorMessage);
        const cart = await response.json();
        renderDrawer(cart);
        document.dispatchEvent(new CustomEvent('sundae:cart-changed', { detail: { cart } }));
      } catch (error) {
        showToast(error.message || drawer.dataset.errorMessage, true);
        await refreshDrawer();
      } finally {
        drawerBusy = false;
      }
    };
    const openDrawer = () => {
      if (typeof drawer.showModal !== 'function') {
        drawer.setAttribute('open', '');
      } else if (!drawer.open) {
        drawer.showModal();
      }
      document.body.classList.add('sundae-cart-drawer-open');
      refreshDrawer();
    };
    const closeDrawer = () => {
      if (typeof drawer.close === 'function' && drawer.open) drawer.close();
      else drawer.removeAttribute('open');
      document.body.classList.remove('sundae-cart-drawer-open');
    };

    document.addEventListener('click', (event) => {
      const cartLink = event.target.closest('[data-cart-link]');
      if (!cartLink) return;
      event.preventDefault();
      openDrawer();
    });
    drawer.querySelectorAll('[data-close-cart-drawer]').forEach((button) => button.addEventListener('click', closeDrawer));
    drawer.addEventListener('click', (event) => { if (event.target === drawer) closeDrawer(); });
    drawer.addEventListener('close', () => document.body.classList.remove('sundae-cart-drawer-open'));
    document.addEventListener('sundae:cart-changed', (event) => { if (event.detail?.cart) updateCartCount(event.detail.cart); });
    document.addEventListener('sundae:cart-added', (event) => {
      showToast(event.detail?.message || toast.dataset.addedMessage);
      fetchCart().then(updateCartCount).catch(() => {});
    });
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.sundae-card__form, .sundae-product__form');
      if (!form) return;
      event.preventDefault();
      const submitter = event.submitter;
      const buyNow = Boolean(submitter?.hasAttribute('data-sundae-buy-now'));
      const formOwner = form.closest('[data-product-section]') || form;
      const buttons = [...formOwner.querySelectorAll('button[type="submit"]')];
      const buttonStates = buttons.map((button) => ({ button, text: button.textContent, disabled: button.disabled }));
      buttons.forEach((button) => { button.disabled = true; });
      if (submitter?.dataset.loadingLabel) submitter.textContent = submitter.dataset.loadingLabel;
      try {
        const response = await fetch(toast.dataset.cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || toast.dataset.errorMessage);
        const cart = await fetchCart();
        updateCartCount(cart);
        if (buyNow) {
          window.location.assign(toast.dataset.checkoutUrl);
          return;
        }
        showToast(toast.dataset.addedMessage);
      } catch (error) {
        showToast(error.message || toast.dataset.errorMessage, true);
      } finally {
        buttonStates.forEach((state) => {
          state.button.textContent = state.text;
          state.button.disabled = state.disabled;
        });
      }
    });
    closeToastButton.addEventListener('click', () => {
      window.clearTimeout(dismissTimer);
      toast.hidden = true;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
